import { FC, useCallback, useMemo } from 'react'
import * as styles from 'components/features/pfm/RateTabs/RateTabs.css'
import PercentageBadge from 'components/atoms/PercentageBadge'
import { getRateDescription } from 'helpers/accountHelpers'
import { AccountTyped, BaseCategoryInterest } from 'interfaces/accounts'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import { OPPORTUNITIES_PAGE } from 'constants/pages'
import Button from 'components/features/pfm/Button/Button'
import isNumber from 'lodash/isNumber'
import { useStoreDispatch, useStoreSelector } from 'helpers/reactReduxHelpers'
import { opportunityCountersSelector } from 'selectors/oppertunitiesSelectors'
import { OpportunityCategoryId } from 'interfaces/meta'
import { setFilterCategoryActionCreator } from 'actions/globalActions'
import { OpportunityPlacement } from 'interfaces/opportunities'

type RateTabContentProps =
  & AccountTyped
  & {
    activeTab: BaseCategoryInterest
    placement: OpportunityPlacement
  }
export const RateTabContent: FC<RateTabContentProps> = (props) => {
  const { activeTab, type } = props

  const dispatch = useStoreDispatch()
  const handleClick = useCallback((categoryId: OpportunityCategoryId) => {
    dispatch(setFilterCategoryActionCreator(OPPORTUNITIES_PAGE, categoryId))
  }, [dispatch])

  const opportunityCounters = useStoreSelector((state) => opportunityCountersSelector(state, props))
  const opportunitiesButtonChild = useMemo(() => {
    const { categoryId, allAccountsCount } = activeTab
    const adjustedCategoryId = (categoryId === 'all' ? 'top' : categoryId) as OpportunityCategoryId
    const counter = opportunityCounters && opportunityCounters[adjustedCategoryId]

    if (!isNumber(counter) || allAccountsCount === 0) {
      return null
    }

    return (
      <div className={ styles.buttonWrapper }>
        <NavigationLink
          to={ OPPORTUNITIES_PAGE }
          onClick={ () => handleClick(adjustedCategoryId) }
        >
          <Button
            size='small'
            fullHeight
            fullWidth
          >
            { categoryId === 'all' && 'See all opportunities' }
            { categoryId !== 'all' && `See ${ counter } ${ counter === 1 ? 'opportunity' : 'opportunities' }` }
          </Button>
        </NavigationLink>
      </div>
    )
  }, [activeTab, handleClick, opportunityCounters])

  return (
    <section className={ styles.content }>
      <div className={ styles.badgeTextWrapper }>
        <div className={ styles.competitiveBadge }>
          <PercentageBadge { ...activeTab } />
        </div>
        <div className={ styles.text }>
          { getRateDescription(activeTab, type) }
        </div>
      </div>
      { opportunitiesButtonChild }
    </section>
  )
}
